// Navigation des Moduls `vertraege` (eager geladen; Quelle UX §2.2–§2.10). Besitzer: Modul vertraege.
import { FileText, Files } from '@phosphor-icons/react';
import { defineMeta } from '@web/registry/define';

export default defineMeta({
  key: 'vertraege',
  title: 'Contracts',
  nav: {
    people: [
      {
        key: 'vertraege.tab',
        label: 'Contract',
        icon: FileText,
        path: '/contract',
        roles: ['ALL'],
        order: 30,
        area: 'tabs:rewards',
      },
    ],
    admin: [
      {
        key: 'vertraege.contracts',
        label: 'Contracts',
        icon: FileText,
        path: '/contracts',
        roles: ['ADM', 'HR', 'COMP', 'CL', 'CEO'],
        order: 130,
        area: 'People ops',
        readOnly: ['CL', 'CEO'],
      },
      {
        key: 'vertraege.templates',
        label: 'Contract templates',
        icon: Files,
        path: '/contracts/templates',
        roles: ['ADM', 'HR'],
        order: 140,
        area: 'People ops',
      },
    ],
  },
});
